// extracted by mini-css-extract-plugin
export default {"filterChip":"FilterItem_filterChip__JW7e-","disabled":"FilterItem_disabled__WB4WG","close":"FilterItem_close__LNE0a"};